// Acciones masivas sobre una seleccion (spec §4.6). Puro y testeable: la
// seleccion casi siempre es MIXTA (unos sin inscribir, otros pendientes, otros
// ya activos), asi que cada accion actua solo sobre las filas donde aplica y
// avisa que quedo fuera. Nunca falla en silencio ni a medias.

export const particionarSeleccion = (filas = []) => ({
  // Sin inscripcion -> se pueden inscribir (quedan en pendiente).
  inscribibles: filas.filter((f) => !f.inscrito),
  // Pendientes que cumplen todas las reglas.
  activables: filas.filter((f) => f.inscrito && f.puedeActivar),
  // Pendientes que NO cumplen: el motivo se le dice al usuario.
  noActivables: filas.filter(
    (f) => f.inscrito && f.estatusGuardado === 'pendiente' && !f.puedeActivar,
  ),
  // Todo lo inscrito que no este ya de baja.
  bajables: filas.filter((f) => f.inscrito && f.estatusGuardado !== 'baja'),
})

// Por que no hay nada que activar. Decir solo "ninguno esta pendiente" es cierto
// y no sirve: el caso normal es que aun no los hayan inscrito, y hay que decirles
// el siguiente paso.
export const motivoNadaQueActivar = (filas = []) => {
  const { inscribibles, noActivables } = particionarSeleccion(filas)
  const partes = []
  if (inscribibles.length) {
    const n = inscribibles.length
    partes.push(
      n === 1
        ? '1 aún no está inscrito: inscríbelo primero y luego actívalo.'
        : `${n} aún no están inscritos: inscríbelos primero y luego actívalos.`,
    )
  }
  const aviso = resumenNoActivados(noActivables)
  if (aviso) partes.push(aviso)
  if (!partes.length) return 'Los seleccionados ya están activos o dados de baja.'
  return partes.join(' ')
}

// "2 no se activaron: falta Datos válidos (CURP), Consentimiento"
export const resumenNoActivados = (noActivables = []) => {
  if (!noActivables.length) return null
  const faltantes = new Set()
  for (const f of noActivables) {
    for (const r of f.reglas || []) {
      if (r.aplica && !r.cumple) faltantes.add(r.label)
    }
  }
  const motivos = [...faltantes]
  const n = noActivables.length
  const plural = n === 1 ? 'no se activó' : 'no se activaron'
  return motivos.length
    ? `${n} ${plural}: falta ${motivos.join(', ')}.`
    : `${n} ${plural}.`
}
